const common = {
  common: {
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    back: "Back",
    next: "Next",
    submit: "Submit",
    search: "Search",
    filter: "Filter",
    moreInfo: "More Information",
    lessInfo: "Less Information",
    previous: "Previous",
    retry: "Retry",
  },
  
  general: {
    back: "Back",
    cancel: "Cancel",
    confirm: "Confirm",
    error: "Error",
    loadingText: "Loading...",
    noSearchResults: "No results match your search",
    retry: "Retry",
    search: "Search",
  },
};

export default common; 